module.exports = {"pathContext":{"name":"StockTransferTemplateEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"StockTransferTemplate","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-stock-transfer-template-edge.json
// module id = 2025
// module chunks = 67649646403732